module.exports = __webpack_public_path__ + "img/八仙问道.0c8b16d0.jpg";